import axios from 'axios';
import { useState } from 'react';
import FileMetadataModel from '../models/FileMetadataModel';

const api = process.env.REACT_APP_MVRB_DATA_API_URL;

export const useGetFileMetadata = () => {
  const [isFetchingMetadata, setFetchingMetadata] = useState(false);

  const getFileMetadata = async fileNumber => {
    try {
      setFetchingMetadata(true);
      const { data } = await axios.get(`${api}/getFile`, {
        params: {
          name: fileNumber,
        },
      });

      if (data && data[0]) {
        return new FileMetadataModel(data[0]);
      }
    } catch (e) {
      return null;
    } finally {
      setFetchingMetadata(false);
    }
  };

  return {
    getFileMetadata,
    isFetchingMetadata,
  };
};
